const APPROVALS_REQUESTED = "EVT_APP_APPROVALS_REQUESTED";
const APPROVALS_RECEIVED = "EVT_APP_APPROVALS_RECEIVED";
const FETCH_APPROVALS_FAILED = "EVT_APP_FETCH_APPROVALS_FAILED";

const simpleEvent = type => {
    const evt = {type};
    return () => evt;
};

const dataEvent = type => {
    return data => {
        return {type, data};
    };
}

const createApprovalsRequested = simpleEvent(APPROVALS_REQUESTED);
const createApprovalsReceived = dataEvent(APPROVALS_RECEIVED);
const createFetchApprovalsFailed = simpleEvent(FETCH_APPROVALS_FAILED);


const update = (model, event) => {
    const current = model || {};
    const type = (event || {}).type;

    if (type === APPROVALS_REQUESTED) {
        return {...current, APpr_approvalsRequested: true};
    }

    if (type === APPROVALS_RECEIVED) {
        return {...current, APpr_approvals: event.data || [], APpr_approvalsRequested: false};
    }

    if (type === FETCH_APPROVALS_FAILED) {
        return {...current, APpr_approvalsRequested: false};
    }

    return current;
};


const approvalsOf = state => (state && state.APpr_approvals) || [];
const approvalsRequestedOf = state => !!state && !!state.APpr_approvalsRequested;

// exported for interop, not intended for view
// maybe I should make them their own module, not sure
// or maybe they should be defined in interop ????
// this is all kind of prototype-y until I get my head
// around how i want do to effectful things
const eventTypes = {
    APPROVALS_REQUESTED,
    APPROVALS_RECEIVED,
    FETCH_APPROVALS_FAILED
};

export {
    createApprovalsRequested,
    createApprovalsReceived,
    createFetchApprovalsFailed,
    update,
    eventTypes,
    approvalsOf,
    approvalsRequestedOf
}



// WEBPACK FOOTER //
// ./src/approvals/model.js